import { iconCopyWhite, iconEmailWhite } from 'assets/icons';
import { Badge } from 'components/Badge';
import { Button } from 'components/Button';
import { Tooltip } from 'components/Tooltip';
import { AuthConnectionErrorProps, useAuth } from 'hooks/useAuth';
import { useHomeParams } from 'hooks/usePagesParams/useHomeParams';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { asParams } from 'utils/asParams';
import { copyToClipboard } from 'utils/copyToClipboard';
import { formattingDate, formattingOnlyNumberCurrency } from 'utils/formattingInputs';

import { StoreCard } from './styles';

interface ParamsURLProps {
  id: string;
}

interface RequestProps {
  transactionId: string,
  amount: number,
  logo: string,
  nickName: string,
  surveyUrl: string,
  transactionItens: string[],
  transactionStatus: string,
  transactionDate: string,
}


export const useRequestsTable = () => {
  const {id} = useParams<ParamsURLProps>();
  const {connectApi, cancelRequest} = useAuth();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const [requests, setRequests] = useState<RequestProps[]>([]);
  const [requestsCount, setRequestsCount] = useState(0);
  const {params, setParams} = useHomeParams();
  const [pageNumber, setPageNumber] = useState<number>(params?.PageNumber ?? 1);
  const [requestsPerPage, setRequestsPerPage] = useState<number>(params?.RowsPerPage ?? 10);  

  const handlePageSelected = (page: number):void => {
    setPageNumber(page);
  }

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>):void => {
    const eventName = event.target.name;
    const eventValue = event.target.value;
    setRequestsPerPage(parseInt(eventValue));
  }

  const handleClickReesend = async (event: any) => {
    const transactionId = event.target.value;
    connectApi({
      type: 'post',
      url: `transactions/${transactionId}/send-email`,
      successMessage: 'E-mail enviado com sucesso!',
      errorMessage: 'Falha ao enviar e-mail'
    });
  }

  const rowItemsTable = ({...props}: RequestProps) => {
    const newArray: any = [];
    const limitItems = 2;

    if(props.transactionItens && props.transactionItens.length <= 0) return

    props.transactionItens.map((item, index) => (  
      index < limitItems && (newArray.push(<div>{item}</div>))
    ))

    if(props.transactionItens.length > limitItems) {
      const overItem = props.transactionItens.length-limitItems;
      newArray.push(<Badge 
        fontSize={14} 
        fontWeight={500}
        margin="8px 0 0 0" 
        key={props.transactionItens.length} 
        value={String(`+${overItem} ${overItem > 1 ? "itens" : "item"}`)}
      />)
    }

    return newArray;
  }

  const storeTable = ({ ...props}: RequestProps) => {
    return (
      <StoreCard>
        <figure>
          <img src={props.logo} alt="" />
        </figure>
        <span>{props.nickName}</span>
      </StoreCard>
    )
  } 

  const buttonTable = ({ ...props }: RequestProps) => {
    return (
      <div className="tbody-flex">
        {props.surveyUrl ?
          <>
            <Tooltip text="Copiar link pesquisa">
              <Button 
                label=""
                typeBtn="blue" 
                value={props.surveyUrl} 
                size="small" 
                icon={iconCopyWhite} 
                onlyIcon={true} 
                onClick={copyToClipboard} 
              />
            </Tooltip>
          </>
          : null
        }

        <Tooltip text="Enviar email de pesquisa">
          <Button 
            label="" 
            value={props.transactionId} 
            typeBtn="blue"
            size="small" 
            icon={iconEmailWhite}
            onlyIcon={true} 
            onClick={handleClickReesend} 
          />
        </Tooltip>
      </div>
    )
  }

  const getRequests = async () => {
    setLoading(true);
    connectApi({
      type: 'get', 
      url: `transactions?customerId=${id}&${filtersAsParams()}`, 
      errorMessage: 'Falha ao lista cupons'
    }).then((response) => {
      setError(false);
      setRequestsCount(response.data.count);
      setRequests(response.data.data.map((item:any) => ({
        transactionDate: formattingDate(item.transactionDate, true),
        transactionStatus: item.transactionStatus,
        nickName: storeTable(item),
        transactionItens: rowItemsTable(item),
        amount: formattingOnlyNumberCurrency(item.amount),
        tdButton: buttonTable(item)
      })));
      setLoading(false);
    }).catch((error: AuthConnectionErrorProps) =>{
      if (error.errorType === 'connection') {
        setError(true);
        setLoading(false);
      }
    });
  }

  const filtersAsParams = ():string => {
    var filters = [];
    filters.push({key: 'PageNumber', value: pageNumber.toString()});
    filters.push({key: 'RowsPerPage', value: requestsPerPage.toString()});
    return asParams(filters);
  };

  useEffect(() => {
    setParams?.({
      ...params,
      PageNumber: pageNumber,
      RowsPerPage: requestsPerPage,
    });
    getRequests();
  }, [pageNumber, requestsPerPage]);

  useEffect(() => {
    setPageNumber(1);
  }, [requestsPerPage]);

  return {
    loading,
    error,
    requests,
    requestsCount,
    pageNumber,
    requestsPerPage,
    handlePageSelected,
    handleRowsPerPageChange,
  };
}